<template>
    <div id="maptitle">
        <HomeButton :backURL="themeURL"></HomeButton>
        <h5>{{ mapTitle }}</h5>
    </div>
</template>
<script>
import HomeButton from "@/components/HomeButton.vue";
export default {
    name: "TitleBlock",
    components: {
        HomeButton,
    },
    props: {
        mapTitle: String,
        themeURL: String,
    },
};
</script>
<style scoped>
#maptitle {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    background-color: rgba(255, 255, 255, 1);
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-left: 15px;
    display: grid;
    grid-template-columns: auto 1fr;
    place-items: center;
}
h5 {
    margin-bottom: 0 !important;
    margin-top: 10px;
    vertical-align: middle;
    line-height: 1 !important;
}

@media (max-width: 750px) {
    #maptitle {
        background-color: rgba(255, 255, 255, 0.7);
    }
}
</style>
